import React from 'react';
import {TouchableOpacity, Text, ColorValue} from 'react-native';
import {BottomTabBarProps} from '@react-navigation/bottom-tabs';
import {View} from 'native-base';

import {navigationStyle} from './navigation.styles';
import {ThemeContext} from '../contextAPI/themeContext';
import {FixedValue, COLORS, navigationEmitType} from '../constants';
import TabBarIcons from './tabBarIcons';
import {useAppDispatch} from '../hooks/reduxHooks';
import {onNotificationCountStart} from '../redux/reducers/notificationSlice';

const CustomeWebTabBar = ({
  state,
  descriptors,
  navigation,
}: BottomTabBarProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const {ColorTheme} = React.useContext(ThemeContext);
  const {styles, ids} = navigationStyle(ColorTheme);

  return (
    <>
      <View
        style={styles.webTabBarStyle}
        dataSet={{media: ids.webTabBarStyle}}
        shadow={FixedValue.CONSTANT_VALUE_5}
      >
        {state.routes.map((route, index) => {
          const {options} = descriptors[route.key];
          const label: string =
            options.title !== undefined ? options.title : route.name;
          const isFocused: boolean = state.index === index;
          const IconColors: ColorValue = isFocused
            ? COLORS.PRIMARY_BLUE
            : COLORS.BLACK;

          const onPress = (): void => {
            const event = navigation.emit({
              type: navigationEmitType.TAB_PRESS,
              target: route.key,
              canPreventDefault: true,
            });

            if (!isFocused && !event.defaultPrevented) {
              dispatch(onNotificationCountStart());
              navigation.navigate(route.name);
            }
          };

          const onLongPress = (): void => {
            navigation.emit({
              type: navigationEmitType.TAB_LONG_PRESS,
              target: route.key,
            });
          };

          return (
            <TouchableOpacity
              key={label}
              accessibilityRole="button"
              accessibilityState={isFocused ? {selected: true} : {}}
              accessibilityLabel={options.tabBarAccessibilityLabel}
              onPress={onPress}
              onLongPress={onLongPress}
              style={styles.singleTabView}
            >
              <View style={styles.iconView} dataSet={{media: ids.iconView}}>
                <TabBarIcons
                  TabName={options.title}
                  stroke={IconColors}
                  focused={isFocused}
                />
              </View>
              <Text
                style={{...styles.labelText, color: IconColors}}
                dataSet={{media: ids.labelText}}
              >
                {label}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </>
  );
};

export default React.memo(CustomeWebTabBar);
